<template>
    <VueRecaptcha
      :sitekey="siteKey"
      :load-recaptcha-script="true"
      @verify="handleSuccess"
      @error="handleError"
    ></VueRecaptcha>
  </template>
  
  <script>
  import { VueRecaptcha } from 'vue-recaptcha'
  
  export default{
    name: 're-captcha',
    components: {
      VueRecaptcha
    },
    data () {
    return {
      siteKey: '6LdZKbAiAAAAACrb3VUd__uumFT6Tyari1uOBG7o'
    }
  },
    methods: {
      handleError: function () {
        return false
      },
     handleSuccess: function () {
       return true
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/base/captcha/ReCaptcha.vue